import React, { useState } from 'react';

const MetricGauge = ({ score, summaryGauge = false }) => {
    const [showTooltip, setShowTooltip] = useState(false);

    const handleTooltipPosition = (e) => {
        const gaugeElement = e.currentTarget;
        const tooltipElement = gaugeElement.querySelector('.metric-tooltip');
        const arrowElement = tooltipElement?.querySelector('.metric-tooltip-arrow');
        if (!tooltipElement) return;
        
        const gaugeRect = gaugeElement.getBoundingClientRect();
        const tooltipRect = tooltipElement.getBoundingClientRect();
        
        // For summary gauges, use different positioning
        if (gaugeElement.classList.contains('summary-gauge-container')) {
            // Position tooltip in the center of the gauge, but check boundaries
            const viewportWidth = window.innerWidth;
            let left = gaugeRect.left + (gaugeRect.width / 2) - (tooltipRect.width / 2);
            
            // Adjust if tooltip would overflow viewport
            if (left < 10) left = 10;
            if (left + tooltipRect.width > viewportWidth - 10) {
                left = viewportWidth - tooltipRect.width - 10;
            }
            
            // Position the tooltip
            tooltipElement.style.left = `${left}px`;
            tooltipElement.style.top = `${gaugeRect.top - tooltipRect.height - 8}px`;
            
            // Position the arrow to point to the gauge
            if (arrowElement) {
                const idealArrowLeft = gaugeRect.left + (gaugeRect.width / 2) - left;
                arrowElement.style.left = `${Math.max(10, Math.min(tooltipRect.width - 10, idealArrowLeft))}px`;
            }
        } else {

            // Calculate the ideal centered position
            let left = gaugeRect.left + (gaugeRect.width / 2) - (tooltipRect.width / 2);
            let top = gaugeRect.top - tooltipRect.height - 8; // 8px for spacing
            
            // Check boundaries
            const viewportWidth = window.innerWidth;
            const rightOverflow = left + tooltipRect.width > viewportWidth;
            const leftOverflow = left < 0;
        
            // Adjust horizontal position if needed
            if (rightOverflow) {
                left = viewportWidth - tooltipRect.width - 8; // 8px padding from viewport edge
            } else if (leftOverflow) {
                left = 8; // 8px padding from viewport edge
            }
        
            // Position the tooltip
            tooltipElement.style.left = `${left}px`;
            tooltipElement.style.top = `${top}px`;
            
            // Position the arrow
            if (arrowElement) {
                const idealArrowLeft = gaugeRect.left + (gaugeRect.width / 2) - left;
                arrowElement.style.left = `${Math.max(10, Math.min(tooltipRect.width - 10, idealArrowLeft))}px`;
            }
        }
    };

    const getScoreColor = (score) => {
        if (score >= 80) return '#10b981';
        if (score >= 60) return '#2563eb';
        if (score >= 40) return '#eab308';
        if (score >= 20) return '#f97316';
        return '#ef4444';
    };

    const radius = 20;
    const strokeWidth = 5;
    const circumference = radius * Math.PI;
    const progressLength = (score / 100) * circumference;

    return (
        <div 
            className={`gauge-container ${summaryGauge ? 'summary-gauge-container' : ''}`}
            onMouseEnter={(e) => {
                setShowTooltip(true);
                handleTooltipPosition(e);
            }}
            onMouseLeave={() => setShowTooltip(false)}
            onClick={(e) => {
                setShowTooltip(!showTooltip);
                if (!showTooltip) handleTooltipPosition(e);
            }}
        >
            <svg 
                className="transform rotate-180" 
                width={(radius * 2) * 1} // add factor to increase size
                height={(radius + strokeWidth) * 1}
                viewBox={`0 0 ${radius * 2} ${radius + strokeWidth}`}
            >
                {/* Background track */}
                <path
                    d={`M ${strokeWidth/2},${radius + strokeWidth/2} A ${radius-strokeWidth/2},${radius-strokeWidth/2} 0 0 1 ${2*radius-strokeWidth/2},${radius + strokeWidth/2}`}
                    fill="none"
                    stroke="rgba(255,255,255,0.1)"
                    strokeWidth={strokeWidth}
                    strokeLinecap="round"
                />
                {/* Colored progress */}
                <path
                    d={`M ${strokeWidth/2},${radius + strokeWidth/2} A ${radius-strokeWidth/2},${radius-strokeWidth/2} 0 0 1 ${2*radius-strokeWidth/2},${radius + strokeWidth/2}`}
                    fill="none"
                    stroke={getScoreColor(score)}
                    strokeWidth={strokeWidth}
                    strokeLinecap="round"
                    strokeDasharray={`${progressLength} ${circumference}`}
                />
                {/* Score text */}
                <text
                    x={radius}
                    y={radius}
                    fill={getScoreColor(score)}
                    fontSize="10"
                    textAnchor="middle"
                >
                    {Math.round(score)}%
                </text>
                {/* Optional: Add a small dot at the end of the progress */}
                {score > 0 && (
                    <circle
                        cx={radius + (radius - strokeWidth/2) * Math.cos(Math.PI * (1 - score/100))}
                        cy={radius + strokeWidth/2 - (radius - strokeWidth/2) * Math.sin(Math.PI * (1 - score/100))}
                        r={strokeWidth/2}
                        fill={getScoreColor(score)}
                    />
                )}
            </svg>
            {showTooltip && (
            <div className={`metric-tooltip ${summaryGauge ? 'summary-tooltip' : ''}`}>
                {summaryGauge ? (
                    <>Besser als {Math.round(score)}%</>
                ) : (
                    <>Dieser Wert ist besser als bei {Math.round(score)}% der berücksichtigten Unternehmen</>
                )}
                <div className="metric-tooltip-arrow"></div>
            </div>
            )}
        </div>
    );
};

export default MetricGauge;